import { handleRequest } from "../utilities/requestHandler";

export const getCustomersCusSites = () =>
    handleRequest("get","/cus_sites/getcustomers");

export const updateCustomer = (customerId, customerData) =>
    handleRequest("put", `/cus_sites/customers/${customerId}`, customerData);

export const createCustomer = (customerData) =>
    handleRequest("post", "/cus_sites/customers/create", customerData);

export const deleteCustomers = (ids) =>
    handleRequest("post", "/cus_sites/customers/delete", { ids });

export const downloadCustomerTemplate = () =>
    handleRequest("get", "/cus_sites/customers/template", null, {}, "blob");

export const bulkUploadCustomers = (formData) =>
    handleRequest("post", "/cus_sites/customers/bulk-upload", formData, { 'Content-Type': 'multipart/form-data' });